import { ClientPrivileges } from "../authentication/ClientPrivilegesEnum";

export enum ReportSubscriptionTypeEnum {
    DevicesContentReport = 0,
    LastDayTransactionsReport = 1,
    PlatformMaintenanceReport = 3,
    LastDayFrontBackOfficeReport = 4,
}

export function getSubscriptionTypeLabel(t: string): string {
    switch (parseInt(t) as ReportSubscriptionTypeEnum) {
        case ReportSubscriptionTypeEnum.DevicesContentReport:
            return "reportSubscription.devicesContentReport";
        case ReportSubscriptionTypeEnum.LastDayTransactionsReport:
            return "reportSubscription.lastDayTransactionsReport";
        case ReportSubscriptionTypeEnum.PlatformMaintenanceReport:
            return "reportSubscription.platformMaintenanceReport";
        case ReportSubscriptionTypeEnum.LastDayFrontBackOfficeReport:
            return "reportSubscription.lastDayFrontBackOfficeReport";
        default:
            return "common.unknown";
    }
}

export function getSubscriptionRequiredPrivileges(t: string): ClientPrivileges {
    switch (parseInt(t) as ReportSubscriptionTypeEnum) {
        case ReportSubscriptionTypeEnum.DevicesContentReport:
            return ClientPrivileges.CashFlowContentMonitoring;
        case ReportSubscriptionTypeEnum.LastDayTransactionsReport:
            return ClientPrivileges.CashFlowTransactionsReporting;
        case ReportSubscriptionTypeEnum.PlatformMaintenanceReport:
            return ClientPrivileges.PlatformMaintenance;
        case ReportSubscriptionTypeEnum.LastDayFrontBackOfficeReport:
            return ClientPrivileges.CashFlowBranchReporting;
        default:
            return ClientPrivileges.None;
    }
}

export function getSubscriptionFormats(t: string): string[] {
    switch (parseInt(t) as ReportSubscriptionTypeEnum) {
        case ReportSubscriptionTypeEnum.DevicesContentReport:
            return ["pdf", "csv"];
        case ReportSubscriptionTypeEnum.LastDayTransactionsReport:
            return ["csv"];
        case ReportSubscriptionTypeEnum.PlatformMaintenanceReport:
            return [];
        case ReportSubscriptionTypeEnum.LastDayFrontBackOfficeReport:
            return ["pdf", "csv"];
        default:
            return [];
    }
}
